(ns ductile.uis)

(defn class-vec
  ([x] (if (string? x) [x] x))
  ([x & xs] (-> (class-vec x)
                (concat (map class-vec xs))
                flatten
                vec)))

(defn opts+content [content]
  (if (map? (first content))
    [(first content) (rest content)]
    [{} (into [] content)]))

(defn vin [v]
  (when v [:span.tabular-nums
           (apply str (drop-last 7 v))
           [:span.font-bold (apply str (take-last 7 v))]]))

(defn link-opts->classes [{:keys [variant disabled? class]}]
  (class-vec
   ["hover:underline" "focus-visible:underline" "inline-flex" "flex-shrink-0" "gap-1" "items-center" "cursor-pointer" "focus-visible:outline-none"]
   (get {:primary ["text-indigo-700" "hover:text-indigo-600" "focus-visible:text-indigo-600" "active:text-indigo-500"]
         :destructive ["text-red9" "hover:text-red10" "focus-visible:text-red10" "active:text-red11"]} variant)
   (when disabled? ["opacity-70 pointer-events-none"])
   class))

(defn link [& content]
  (let [[opts content] (opts+content content)]
    (into [(:as opts :a)
           (merge (when (and (:as opts) (not= :a (:as opts))) {:href "#"})
                  (dissoc opts :variant :disabled? :as)
                  {:tab-index 0
                   :class (link-opts->classes (merge {:size 2 :variant :primary} opts))}
                  #?(:cljs (when (:on-click opts)
                             {:on-key-down (fn [^js e]
                                             (when (contains? #{"Enter" "Space"} (.-code e))
                                               (.preventDefault e)
                                               ((:on-click opts) e)))})
                     :clj nil))]
          content)))
